import CallToAction from "@/components/Button";
import { forwardRef } from "react";
import styled from "styled-components";
import { SVGArrowBottom } from "@/lib/svg";

export const Icon = styled(SVGArrowBottom)`
  font-size: 0.6em;
`;

const _Button = forwardRef<HTMLButtonElement, any>((props, ref) => (
  <CallToAction ref={ref} variant="primaryBoxed" icon={<Icon />} {...props} />
));

_Button.displayName = "Button";

export const Button = styled(_Button)`
  margin: 5rem auto 0;
  width: max-content;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
